






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
  
      if(context.root.$route.query.confirm_login == "true" && !window.confirm("現在ログイン中のユーザの処理が中断されます。本当によろしいですか？")){
        context.root.$router.push("/").catch(err => {});
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/classroom_sessions/student_login`, {token: context.root.$route.query.t}).then(response => {
        
        var user = response.data.user;

        // トークン設定
        var token = user.access_token
        document.cookie = `access_token=${token}`;
        document.cookie = 'smarky_user_id=' + user.id;

        context.root.$store.commit("setCurrentUser", user);
        context.root.$store.commit("setCurriculums", response.data.curriculums);
        context.root.$store.commit("setStudentNoCharacter", response.data.student_no_character);

        context.root.$router.push(`/${context.root.$route.params.school_id}/student_site/sheet_list`).catch(err => {});
        context.root.$store.commit("setIsHeaderDisp", true);
      })
      .catch(error=>{
        // エラーの場合はログイン画面に戻る
        context.root.$router.push(`/${context.root.$route.params.school_id}/student_site/sign_in?error_kind=${error.response.data.error_kind}`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
